// Shared verified replacement: complete before leaving the editor; retain cart fallback.
window.HanossFinalizeCartEdit = async () => {
  const pending = JSON.parse(sessionStorage.getItem('hn-hng04-cart-legacy-replace') || 'null');
  if (!pending || pending.expires < Date.now() || !Array.isArray(pending.before)) {
    sessionStorage.removeItem('hn-hng04-cart-legacy-replace');
    return null;
  }
  const cartResponse = await fetch('/cart.js', { signal: AbortSignal.timeout(15000) });
  if (!cartResponse.ok) throw new Error('Cart unavailable');
  const cart = await cartResponse.json();
  const before = new Map(pending.before.map((item) => [item.key, item.quantity]));
  const matchesExpected = (item) => item.product_id === pending.expected?.productId
    && item.key !== pending.lineKey
    && item.variant_id === pending.expected?.variantId
    && pending.expected?.properties
    && Object.entries(pending.expected.properties).every(([key, value]) => item.properties?.[key] === value)
    && item.properties?.['_customily-personalization-id']
    && item.properties?.['_customily-personalization-id'] !== pending.originalPersonalizationId
    && item.properties?.['_customily-preview'];
  const replacement = cart.items.find((item) => matchesExpected(item)
    && item.quantity > (before.get(item.key) || 0));
  if (!replacement) {
    throw new Error('Saved personalization not found');
  }
  const targetQuantity = pending.requestedQuantity || pending.quantity;
  const changeQuantity = async (key, quantity) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      signal: AbortSignal.timeout(15000),
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!response.ok) throw new Error('Cart update failed');
    return response.json();
  };
  if (replacement.quantity !== targetQuantity) await changeQuantity(replacement.key, targetQuantity);
  const verified = await (await fetch('/cart.js', { signal: AbortSignal.timeout(15000) })).json();
  if (!verified.items.some((item) => item.key === replacement.key && item.quantity === targetQuantity && matchesExpected(item))) throw new Error('Saved personalization not verified');
  let finalCart = verified;
  if (replacement.key !== pending.lineKey && verified.items.some((item) => item.key === pending.lineKey)) {
    await changeQuantity(pending.lineKey, 0);
    finalCart = await (await fetch('/cart.js', { signal: AbortSignal.timeout(15000) })).json();
    if (!finalCart.items.some((item) => item.key === replacement.key && item.quantity === targetQuantity && matchesExpected(item))) throw new Error('Saved personalization not verified');
  }
  if (!finalCart.items.some((item) => item.key === replacement.key && item.quantity === targetQuantity && matchesExpected(item)) || finalCart.items.some((item) => item.key === pending.lineKey)) throw new Error('Cart replacement incomplete');
  sessionStorage.removeItem('hn-hng04-cart-legacy-replace');
  sessionStorage.removeItem('hn-hng04-cart-edit-intent');
  return finalCart;
};
